import { type FC } from "react";

import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

import { fontFamily } from "../../../shared/styles";
import { type OsStatsItem } from "../../models";

const Container = styled.div`
    ${fontFamily};
    padding: 6px 8px;
    text-align: center;
    background: ${Colors.Black.V200};
    border-radius: 6px;
`;

const Label = styled.div`
    ${Fonts.Heading.H600}
    color: ${Colors.WHITE};
`;
const Text = styled.div`
    ${Fonts.Heading.H800}
    color: ${Colors.WHITE};
`;

interface OsTooltipProps {
    active?: boolean;
    payload?: {
        value: number;
        name: string;
        payload: OsStatsItem;
    }[];
}

export const OsTooltip: FC<OsTooltipProps> = ({ active, payload }) => {
    if (!active || !payload || payload.length === 0) {
        return null;
    }

    const label = payload[0]?.name;
    const value = payload[0]?.payload.valuePercent;

    return (
        <Container>
            <Label>{label}</Label>
            <Text>{value} %</Text>
        </Container>
    );
};
